Ext.ns('mx.app.widget');

mx.app.widget.UsersInfoForm = Ext.extend(Ext.Panel, {
    border: false,
    layout: 'mx-form',
    autoHeight: true,
    defaults: {
        anchor: '-5',
    },

    loginDisabled: false,

    showYourPassword: true,
    isNew: null,

    labels: {
        globalId: 'Global Id',
        name: 'Name',
        email: 'E-mail',
        login: 'Login',
        yourPassword: 'Your password',
        newPassword: 'New password',
        repeatPassword: 'Repeat password',
        inviteLink: 'Invite link',
        passwordsDoNotMatch: 'Passwords do not match',
        yourPasswordIsRequired: 'Your password is required to change password',
        changePassword: 'Change password',
        uiLanguage: 'Interface language',
    },

    formName: 'userSettings',

    fieldNames: {
        globalId: 'globalId',
        name: 'name',
        email: 'email',
        login: 'login',
        inviteLink: 'inviteLink',
        password: 'password',
        password_new: 'password_new',
        password_confirm: 'password_new_confirm',
    },
    getForm: function() {
        return this.form;
    },

    initComponent: function() {
        mx.app.widget.UsersInfoForm.superclass.initComponent.apply(this, arguments);

        var yourPassword, newPassword, confirmPassword, changePasswordCheckbox;
        var thiz = this;

        var inviteLinkField = {
            fieldLabel: this.labels.inviteLink,
            xtype: 'textfield',
            maxLength: mx.DEFAULT_MAX_LENGTH,
            name: this.fieldNames.inviteLink,
            formName: this.formName,
            allowBlank: true,
        };

        var globalIdField = new Ext.form.TextField({
            name: this.fieldNames.globalId,
            cls: 'text-field-as-label',
            fieldLabel: this.labels.globalId,
            allowBlank: true,
            readOnly: true,
            maxLength: mx.DEFAULT_MAX_LENGTH,
        });

        this.form = new Ext.form.BasicForm(null, this.initialConfig);
        var inviteLinkButton = new Ext.Button({
            text: 'Get invite link',
            id: 'invite_link_button',
            handler: function() {
                Ext.Ajax.request({
                    url: mx.PATH + MXAT.API('users/inviteLink/' + globalIdField.getValue()),
                    method: 'GET',
                    params: {},
                    scope: this,
                    success: function(r) {
                        var response = Ext.util.JSON.decode(r.responseText);
                        thiz.items.items[4].setValue(response.rows[0]);
                    },
                    failure: function() {
                        thiz.items.items[4].setValue('');
                    },
                });
            },
            minWidth: 100,
            setSize: function() {},
            scope: this,
        });

        this.add(
            globalIdField,
            {
                fieldLabel: this.labels.name,
                xtype: 'textfield',
                name: this.fieldNames.name,
                maxLength: mx.DEFAULT_MAX_LENGTH,
                allowBlank: false,
                formName: this.formName,
            },
            {
                fieldLabel: this.labels.email,
                xtype: 'textfield',
                vtype: 'emailAddress',
                maxLength: mx.DEFAULT_MAX_LENGTH,
                name: this.fieldNames.email,
                formName: this.formName,
                allowBlank: false,
            },
            {
                fieldLabel: this.labels.login,
                disabled: this.loginDisabled,
                maxLength: mx.DEFAULT_MAX_LENGTH,
                xtype: 'textfield',
                name: this.fieldNames.login,
                allowBlank: false,
                formName: this.formName,
            },
            inviteLinkField,
            inviteLinkButton
        );

        var passwordsPanelItems = [];

        if (this.showYourPassword) {
            passwordsPanelItems.push(
                (changePasswordCheckbox = new Ext.form.Checkbox({
                    name: 'suspended',
                    fieldLabel: this.labels.changePassword,
                    listeners: {
                        check: {
                            fn: function(cb, value) {
                                yourPassword.setDisabled(!value);
                                newPassword.setDisabled(!value);
                                confirmPassword.setDisabled(!value);

                                if (!value) {
                                    yourPassword.setValue('');
                                    newPassword.setValue('');
                                    confirmPassword.setValue('');
                                }
                            },
                            scope: this,
                        },
                    },
                }))
            );
            passwordsPanelItems.push(
                (yourPassword = new Ext.form.TextField({
                    fieldLabel: this.labels.yourPassword,
                    xtype: 'textfield',
                    maxLength: mx.DEFAULT_MAX_LENGTH,
                    inputType: 'password',
                    name: this.fieldNames.password,
                    formName: this.formName,
                    disabled: this.showYourPassword,
                    validateValue: function(value) {
                        var newp = newPassword.getValue();
                        if (newp && value.length == 0) {
                            this.markInvalid(thiz.labels.yourPasswordIsRequired);
                            return false;
                        }
                        return true;
                    },
                }))
            );
        }

        passwordsPanelItems.push(
            (newPassword = new Ext.form.TextField({
                fieldLabel: this.labels.newPassword,
                xtype: 'textfield',
                maxLength: mx.DEFAULT_MAX_LENGTH,
                inputType: 'password',
                name: this.fieldNames.password_new,
                formName: this.formName,
                allowBlank: !this.isNew,
                disabled: this.showYourPassword,
                listeners: {
                    blur: {
                        fn: function() {
                            confirmPassword.validateValue(confirmPassword.getValue());
                            if (this.showYourPassword) {
                                yourPassword.validateValue(yourPassword.getValue());
                            }
                        },
                        scope: this,
                    },
                },
            })),
            (confirmPassword = new Ext.form.TextField({
                fieldLabel: this.labels.repeatPassword,
                xtype: 'textfield',
                inputType: 'password',
                maxLength: mx.DEFAULT_MAX_LENGTH,
                name: this.fieldNames.password_confirm,
                formName: this.formName,
                allowBlank: !this.isNew,
                disabled: this.showYourPassword,
                validateValue: function(value) {
                    var newp = newPassword.getValue();
                    if (newp && newPassword.getValue() != value) {
                        this.markInvalid(thiz.labels.passwordsDoNotMatch);
                        return false;
                    }
                    return true;
                },
            }))
        );

        // passwords are in their own "panel" now
        var passwordsPanel = new Ext.Panel({
            border: true,
            header: false,
            layout: 'mx-form',
            items: passwordsPanelItems,
            bodyStyle: 'padding-top: 10px; margin-bottom: 10px;',
            defaults: {
                anchor: '-5',
            },
        });
        this.add(passwordsPanel);

        if (MXBT.get('ipCheckEnabled') == true && !this.hideIpControl) {
            this.add(
                new Ext.form.TextArea({
                    fieldLabel: 'Allowed ip',
                    hint:
                        'Comma-separated list of ips, from which user can access the system. To allow access from ip addresses insert &quot;*&quot; into this list',
                    name: 'ipList',
                })
            );
        }

        var langs = MXBT.get('availableLanguages');

        if (langs && langs.length > 1) {
            var langData = [];

            for (var i = 0; i < langs.length; i++) {
                langData.push([langs[i], MXBT.loc('mx.app.core.languages', langs[i])]);
            }

            var langStore = new Ext.data.SimpleStore({
                fields: ['lang_id', 'lang_name'],
                data: langData,
            });

            var langCombobox = new Ext.form.ComboBox({
                fieldLabel: thiz.labels.uiLanguage,
                store: langStore,
                displayField: 'lang_name',
                valueField: 'lang_id',
                mode: 'local',
                editable: false,
                forceSelection: true,
                triggerAction: 'all',
                emptyText: MXBT.loc('mx.app.core.languages', MXBT.get('currentLanguage')),
            });

            this.form.languageSelector = langCombobox;

            this.add(
                new Ext.Panel({
                    border: false,
                    header: false,
                    layout: 'mx-form',
                    items: [langCombobox],
                    bodyStyle: 'padding-top: 10px;',
                    defaults: {
                        anchor: '-5',
                    },
                })
            );
        }

        this.on(
            'render',
            function() {
                Ext.FormPanel.prototype.initFields.call(this);
            },
            this
        );
    },
});
